import { createSlice } from "@reduxjs/toolkit";

export const get_crop_family = createSlice({
  name: "crop_family",
  initialState: {
    value: { status: false, data: [] },
  },
  reducers: {
    updateStoreCropFamily: (state, action) => {
      state.value.status = true;
      state.value.data = action.payload;
    },
  },
});

export const { updateStoreCropFamily } = get_crop_family.actions;

export default get_crop_family.reducer;
